import React, { useState } from 'react';
import { COLORS } from '../constants/colors';
import { lengthMeasurement, MeasurementSystem, weightMeasurement } from '../enums/measurement-system.enum';

interface Props {
  optionA: MeasurementSystem;
  optionB: MeasurementSystem;
  onOptionSelect: (selectedValue: MeasurementSystem) => void;
  defaultOption: MeasurementSystem;
  isWeightToggle?: boolean;
}

export const SwitchToggle: React.FC<Props> = (props) => {
  const [selectedOption, setSelectedOption] = useState<MeasurementSystem>(props.defaultOption);

  const optionASelected = props.optionA === selectedOption;
  const optionBSelected = props.optionB === selectedOption;

  const buttonStyles: React.CSSProperties = {
    fontSize: 'inherit',
    fontWeight: 'inherit',
    boxSizing: 'content-box',
    letterSpacing: 'inherit',
    border: '1px solid black',
    display: 'inline-block',
    width: '80px',
    padding: '8px',
    textAlign: 'center',
    cursor: 'pointer',
  };

  const renderOption = (system: MeasurementSystem) => (props.isWeightToggle ? weightMeasurement(system) : lengthMeasurement(system));

  return (
    <div
      style={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        color: COLORS.darkGray,
        fontWeight: 'bold',
        justifyContent: 'center',
        alignContent: 'flex-end',
      }}
    >
      <div>
        <button
          onClick={() => {
            setSelectedOption(props.optionA);
            props.onOptionSelect(props.optionA);
          }}
          style={{
            ...buttonStyles,
            backgroundColor: optionASelected ? COLORS.black : COLORS.white,
            color: optionASelected ? COLORS.white : COLORS.black,
            borderTopLeftRadius: '6px',
            borderBottomLeftRadius: '6px',
          }}
        >
          <span>{renderOption(props.optionA)}</span>
        </button>
        <button
          onClick={() => {
            setSelectedOption(props.optionB);
            props.onOptionSelect(props.optionB);
          }}
          style={{
            ...buttonStyles,
            backgroundColor: optionBSelected ? COLORS.black : COLORS.white,
            color: optionBSelected ? COLORS.white : COLORS.black,
            borderTopRightRadius: '6px',
            borderBottomRightRadius: '6px',
          }}
        >
          <span>{renderOption(props.optionB)}</span>
        </button>
      </div>
    </div>
  );
};

export default SwitchToggle;
